import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Button } from '@mui/material';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { colors } from 'z3k-settings/components/utils/ColorPicker4bit';
import { SketchPicker } from 'react-color';
import Rainbow from '../../../images/device-settings-dialog/rainbow.svg';
export const ColorSelection = (props) => {
    const presetColors = colors.map(([color_str, color_lang]) => ({
        color: color_str,
        title: color_lang,
    }));
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', width: '100%' }, children: [_jsx(SketchPicker, { color: props.color, onChange: props.onChange, presetColors: presetColors, disableAlpha: true, styles: {
                    //@ts-ignore
                    picker: { maxWidth: '200px', color: 'black' },
                } }), _jsxs(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '1px',
                }, gap: 1, children: [_jsxs(Button, { sx: {
                            width: '100%',
                        }, children: [_jsx(Avatar, { sx: { width: 18, height: 18 }, children: _jsx(Rainbow, {}) }), _jsx(Box, { ml: 1, onClick: props.setAuto, children: "\u0418\u0437 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A" })] }), !isSmallUI() && (_jsx(Button, { sx: {
                            width: '100%',
                        }, variant: "contained", onClick: props.Close, children: "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C" }))] })] }));
};
